import React from 'react';

export const GameHeading = props => (
	<div className="heading-container" >
		{props.render}
	</div>
);
